import { LoggedUser, User } from "../interfaces/users/UsersInterfaces"

const getLoggedInUser = (): LoggedUser => {
  return JSON.parse(localStorage.getItem("user"))
}

const setLoggedInUser = (user: LoggedUser): void => {
  localStorage.setItem("user", JSON.stringify(user))
}

const updateLoggedInUser = (user: User): void => {
  setLoggedInUser({ ...getLoggedInUser(), user: user })
}

const logout = (): void => {
  localStorage.removeItem("user")
  location.reload()
}

export const authService = {
  logout,
  getLoggedInUser,
  setLoggedInUser,
  updateLoggedInUser,
}
